// extracted by mini-css-extract-plugin
export default {"login-root":"reNGAqUVSwrRnQr4Ob_1","login-form":"MsgZ1Cae6qvshX1niQ8U","login-error-msg":"xv6eSxETFKEVttbvrIp2","copy":"Ht4m_kSvotTSlTPZdfMj"};